import React from 'react';

const getMoviePriceLabel = (movie: any, type: string, text: string, additionalText = '') => {
  const movieData = movie[type];

  if (!movieData || movieData.price === undefined) {
    return `${text} (Preis nicht verfügbar)`;
  }

  let regularPrice = movieData.price.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });
  let promoPrice = null;
  if (movie.promo_prices && movie.promo_prices[type] && movie.promo_prices[type].price !== undefined) {
    promoPrice = movie.promo_prices[type].price.toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });
    if (movie.promotion_only_downloads) {
      if (!type.includes('download')) {
        promoPrice = null;
      }
    }
  }
  const price = promoPrice || regularPrice;

  return (
    <div className="price-wrapper">
      <span>{`${text}`}</span>
      <div className="prices">
        {promoPrice && (
          <span className="price">
            <span className="striked-price">{regularPrice}</span>
          </span>
        )}
        <span>{price}</span>
        <span style={{ marginLeft: '5px' }}>{additionalText}</span>
      </div>
    </div>
  );
};

export default getMoviePriceLabel